module.exports = __webpack_public_path__ + "img/Economy.81db0d18.png";